import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;
let mapPromise = null;
const loadMap = () => {
  if (!mapPromise) mapPromise = fetch(`${API}/api/seo/geo-redirects`).then((r) => (r.ok ? r.json() : {})).catch(() => ({}));
  return mapPromise;
};

// Client-side fallback for merged duplicate geo cities (production serves the SPA statically, so no server 301).
export const GeoRedirectGuard = ({ children }) => {
  const { stateSlug, citySlug, serviceId } = useParams();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    let live = true;
    loadMap().then((m) => {
      const keep = m[`${stateSlug}/${citySlug}`];
      if (keep && keep !== citySlug) {
        const es = window.location.pathname.startsWith('/es/') ? '/es' : '';
        window.location.replace(`${es}/locations/${stateSlug}/${keep}${serviceId ? `/${serviceId}` : ''}${window.location.search}`);
        return;
      }
      if (live) setChecked(true);
    });
    return () => { live = false; };
  }, [stateSlug, citySlug, serviceId]);
  if (!checked) return <div data-testid="geo-redirect-checking" className="min-h-screen" />;
  return children;
};
